import React from "react";
import Fox from "./FoxLight.PNG";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Blog from "./screens/Blog";
import Contact from "./screens/Contact";
import Articel from "./screens/Articel";
import Knowledge from "./screens/Knowledge";
import Lesson from "./screens/Lesson";
import LegalNotice from "./screens/LegalNotice";
import Imprint from "./screens/Imprint";
import StockScreener from "./screens/StockScreener";
import StockInfo from "./screens/StockInfo";
import BookRecommendation from "./screens/BookRecommendation";
import WebsiteOffline from "./screens/WebsiteOffline";
import CompoundInterest from "./screens/CompoundInterest";
import Cashflow from "./screens/Cashflow";
import ReturnOfInvestment from "./screens/ReturnOfInvestment";
import Inflation from "./screens/Inflation";
import ScrollToTop from "./helpers/ScrollToTop/ScrollToTop";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { GlobalContextProvider } from "./context/GlobalContext";
import { HelmetProvider } from "react-helmet-async";
import { NotificationProvider } from "./helpers/useNotifications";

function App() {
  //* if website should be offline or is unnder construction
  if (process.env.REACT_APP_OFFLINE === "true")
    return (
      <GlobalContextProvider>
        <Router>
          <WebsiteOffline />
        </Router>
      </GlobalContextProvider>
    );
  return (
    <NotificationProvider>
      <HelmetProvider>
        <GlobalContextProvider>
          <Router>
            <div className="App bg-dark">
              <Navbar logo={Fox} />
              <div className="content">
                <ScrollToTop />
                <Routes>
                  <Route path="/" element={<Navigate to="/blog" replace />} />
                  <Route path="/blog" element={<Blog title="Blog" />} />
                  <Route
                    path="/blog/stock"
                    element={<StockScreener title="Aktien" />}
                  />
                  <Route path="/blog/stock/:id" element={<StockInfo />} />
                  <Route path="/blog/:blogId/:title" element={<Articel />} />
                  <Route
                    path="/knowledge/stock"
                    element={<Knowledge category="stock" title="Aktienmarkt" />}
                  />
                  <Route
                    path="/knowledge/stock/:id/:title"
                    element={<Lesson />}
                  />
                  <Route
                    path="/knowledge/bond"
                    element={<Knowledge category="bond" title="Anleihen" />}
                  />
                  <Route
                    path="/knowledge/bond/:id/:title"
                    element={<Lesson />}
                  />
                  <Route
                    path="/knowledge/crypto"
                    element={
                      <Knowledge
                        category="crypto"
                        title="Krypto & Blockchain"
                      />
                    }
                  />
                  <Route
                    path="/knowledge/crypto/:id/:title"
                    element={<Lesson />}
                  />
                  <Route
                    path="/knowledge/trading"
                    element={<Knowledge category="trading" title="Trading" />}
                  />
                  <Route
                    path="/knowledge/trading/:id/:title"
                    element={<Lesson />}
                  />
                  <Route path="/tool/cashflow" element={<Cashflow />} />
                  <Route path="/tool/inflation" element={<Inflation />} />
                  <Route path="/tool/roi" element={<ReturnOfInvestment />} />
                  <Route
                    path="/tool/compoundinterest"
                    element={<CompoundInterest />}
                  />
                  <Route path="/book" element={<BookRecommendation />} />
                  <Route path="/contact" element={<Contact />} />

                  <Route path="/imprint" element={<Imprint />} />
                  <Route path="/legal-notice" element={<LegalNotice />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </Router>
        </GlobalContextProvider>
      </HelmetProvider>
    </NotificationProvider>
  );
}

export default App;
